import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from '#app'

import { $t } from '@/utils/index.js'
import { getSassmallToken } from '@/sassmall/storage'
import { legacyPathToUserCenterPath } from '~/user-center/routes'

export function useMallLoginGuard() {
  const router = useRouter()
  const route = useRoute()

  function redirectToLogin() {
    if (!process.client) return
    const currentPath = String(route?.path || '')
    const loginPath = legacyPathToUserCenterPath('/login')
    if (currentPath.startsWith(loginPath)) return
    router.push({
      path: loginPath,
      query: { redirect: route?.fullPath || '' },
    })
  }

  function requireMallLogin() {
    if (!process.client) return false
    if (getSassmallToken()) return true
    ElMessage.error($t('placeholder.pleaseLogined') || '请先登录')
    redirectToLogin()
    return false
  }

  return {
    requireMallLogin,
    redirectToLogin,
  }
}
